import { TeamOutlined } from "@ant-design/icons";
import { ReactComponent as OrganizationIcon } from "Assets/svgs/Organization.svg";
import { TriangleAlert,Building2  } from "lucide-react";

type NavItem = {
  key: string;
  label: string;
  icon: JSX.Element;
  onClick: () => void;
};

export const getNavItems = (navigate: (path: string) => void): NavItem[] => [
  {
    key: "tenants",
    label: "Tenants",
    icon: <OrganizationIcon />,
    onClick: () => navigate("/tenants"),
  },
  {
    key: "organizations",
    label: "Organizations",
    icon: <Building2 size={16}/>,
    onClick: () => navigate("/organizations"),
  },
  {
    key: "users",
    label: "Users",
    icon: <TeamOutlined />,
    onClick: () => navigate("/users"),
  },
  {
    key: "exceptions",
    label: "Exceptions",
    icon: <TriangleAlert size={16} />,
    onClick: () => navigate("/exceptions"),
  },
];
